const page = (data) => {
	const {
		content: { rendered: content },
		title: { rendered: title },
		acf: { entete },
	} = data

	return {
		title,
		content,
		entete,
	}
}

export default page
